"use client";

import Tag from "./Tag";
import Title from "./Title";

/**
 * A reusable section component for landing page sections
 * Follows the DRY principle by unifying the Tag + Title + Container pattern
 */
export default function LandingSection({ 
  tagTitle, 
  tagIconName, 
  tagChildren, 
  title, 
  desc, 
  titleChildren,
  titleClassName,
  children, 
  className = "",
  containerClassName = "container-base xl:container-xl "
}) {
  return (
    <section 
      className={`overflow-hidden ${containerClassName} mx-auto ${className}`}
    >
      {(tagTitle || tagChildren) && (
        <Tag title={tagTitle} iconName={tagIconName}>
          {tagChildren}
        </Tag>
      )}
      {(title || desc || titleChildren) && (
        <Title title={title} desc={desc} className={titleClassName}>
          {titleChildren}
        </Title>
      )}
      {children}
    </section>
  );
}

